"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duration2xfast = exports.durationXfast = exports.durationFast = exports.durationNormal = exports.durationSlow = exports.durationXslow = exports.motionDuration2xfast = exports.motionDurationXfast = exports.motionDurationFast = exports.motionDurationNormal = exports.motionDurationSlow = exports.motionDurationXslow = void 0;
exports.motionDurationXslow = '2000ms';
exports.motionDurationSlow = '1000ms';
exports.motionDurationNormal = '800ms';
exports.motionDurationFast = '500ms';
exports.motionDurationXfast = '200ms';
exports.motionDuration2xfast = '100ms';
exports.durationXslow = '2000ms';
exports.durationSlow = '1000ms';
exports.durationNormal = '800ms';
exports.durationFast = '500ms';
exports.durationXfast = '200ms';
exports.duration2xfast = '100ms';